import { createContext, useContext } from "react";
import { useNavigate } from "react-router-dom";

interface NavigationContextType {
  onNavigate: (page: string, id?: string) => void;
  onBack: () => void;
}

export const NavigationContext = createContext<NavigationContextType | null>(null);

// Mapping des anciens noms de page vers les routes
const routeMap: Record<string, string | ((id?: string) => string)> = {
  dashboard: "/",
  "gestion-operationnelle-user": "/chantiers",
  "mes-transports-user": "/transports",
  "mes-cap-user": "/cap",
  "nouvelle-demande-chantier": "/chantiers/nouveau",
  "nouvelle-demande-transport": "/transports/nouveau",
  "nouveau-chantier": (id) => id ? `/chantiers/${id}/commande` : "/chantiers/commande",
  "nouveau-dechet": (id) => id ? `/chantiers/${id.split(":")[0]}/dechet/nouveau` : "/chantiers",
  "formulaire-devis": "/chantiers/devis",
  "formulaire-devis-transport": (id) => id ? `/transports/${id}/devis` : "/transports/devis",
  "demande-transport": (id) => id ? `/transports/${id}/commande` : "/transports/commande",
  "nouveau-site": "/mes-entreprises",
  "chantier-detail": (id) => id ? `/chantiers/${id}` : "/chantiers",
  "chantier-detail-utilisateur": (id) => id ? `/chantiers/${id}` : "/chantiers",
  "transport-detail": (id) => id ? `/transports/${id}` : "/transports",
  "transport-detail-admin": (id) => id ? `/transports/${id}` : "/transports",
  "devis-factures": "/devis-factures",
  "devis-factures-admin": "/devis-factures",
  "admin-client": (id) => id ? `/etablissements/${id}` : "/etablissements",
  "gestion-operations": (id) => id ? `/operations/${id}` : "/operations",
  "prix-gestion": "/prix",
  profile: "/profil",
  "gestion-etablissement": "/mon-etablissement",
  "documents-administratifs": "/documents",
  "documents-administratifs-admin": "/documents-admin",
  "mes-demandes": "/demandes",
  "types-categories-admin": "/types-categories",
  supervision: "/supervision",
};

export function resolveRoute(page: string, id?: string): string {
  const entry = routeMap[page];
  if (!entry) return "/";
  if (typeof entry === "function") return entry(id);
  return entry;
}

export function useAppNavigation() {
  const ctx = useContext(NavigationContext);
  const navigate = useNavigate();
  if (ctx) return ctx;

  // Fallback si utilise hors du contexte (ne devrait pas arriver).
  return {
    onNavigate: (page: string, id?: string) => {
      navigate(resolveRoute(page, id));
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    onBack: () => navigate(-1),
  };
}
